import {
  Button,
  Center,
  CSSProperties,
  Stack,
  Text,
  Title,
} from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

const styles: { [key: string]: CSSProperties } = {
  root: {
    height: '100vh',
    width: '100vw',
  },
  container: {
    maxWidth: '35%',
  },
  title: {
    fontSize: '10rem',
    fontWeight: 700,
  },
  subTitle: {
    fontSize: '2rem',
  },
};

type ErrorPagePropsType = {
  error: Error;
};

export const ErrorPage: React.FC<ErrorPagePropsType> = ({ error }) => {
  const { t } = useTranslation('error');

  return (
    <Center style={styles.root}>
      <Stack gap={'xl'} style={styles.container}>
        <Title order={1} style={styles.title}>
          {t('TITLE')}
        </Title>
        <Title order={2} style={styles.subTitle}>
          {t('DESCRIPTION')}
        </Title>
        <Text>{t('ERROR_CODE', { message: error.message })}</Text>
        <div>
          <Button component={Link} to="/">
            {t('BACK')}
          </Button>
        </div>
      </Stack>
    </Center>
  );
};
